import React, { useRef, useState } from "react";
import ModalContainer from "../../common/ModalContainer";
import InvoicePDFSection from "../../../sections/invoice/staticPdf/InvoicePDFSection";
import usePDF from "../../../hooks/flight/usePDF";
import useInvoiceApi from "../../../hooks/useInvoiceApi";
import { useSelector } from "react-redux";
import { formatMoney } from "../../../features/utils/formatMoney";
import { getCurrencySymbol } from "../../../features/utils/countires";
import moment from "moment";
import { configurations } from "../../../configurations";
import {
  invoiceSelectedServices,
  invoiceServiceFeeCalculation,
  invoiceTaxCalculation,
} from "../../../controllers/invoiceController";

const pdfData = {
  companyName: "Company name LLC",
  companyLogo:
    "https://plus.unsplash.com/premium_photo-1666277012916-1c1c7bc88122?w=600",
  invoiceNo: "#000123",
  customerName: "Client Name",
  customerAddress: "Address / Contact Info",
  companyAddress: "Address / Contact Info",
  notes: "Have a great day",
  email: "email@company.com",
  paidOn: "December 7, 2022.",
  paymentDue: "December 7, 2022.",
  services: [
    {
      title: "Flight Reservation",
      quantity: "1",
      price: "₦4,000.00",
      total: "₦4,000.00",
      details: [
        "Lagos - London (Return) ",
        "Nov 12 - 24 Dec - British Airways",
      ],
    },
    {
      title: "Flight Reservation",
      quantity: "1",
      price: "₦4,000.00",
      total: "₦4,000.00",
      details: [
        "Lagos - London (Return) ",
        "Nov 12 - 24 Dec - British Airways",
      ],
    },
    {
      title: "Flight Reservation",
      quantity: "1",
      price: "₦4,000.00",
      total: "₦4,000.00",
      details: [
        "Lagos - London (Return) ",
        "Nov 12 - 24 Dec - British Airways",
      ],
    },
  ],
  total: "₦4,000,000.00",
  paymentLink: "https://www.paystack.com/intraverse",
};

export const ConfirmInvoiceModal = ({
  setOpen,
  open,
  data,
  customers,
  onDone,
  onClose,
}) => {
  const { createInvoice } = useInvoiceApi();
  const { services } = useSelector((state) => state.invoice);
  const { handlePDFDownload } = usePDF();
  const [sendLoading, setSendLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  const pdfRef = useRef();

  const customer = () => {
    let item = customers?.find((cust) => cust?.value === data?.customer);
    return {
      name: item?.label,
      email: item?.data?.email,
      address: item?.data?.address,
    };
  };

  const selectedServices = () => invoiceSelectedServices({ data, services });

  const handleExport = async () => {
    if (pdfRef?.current) {
      let string = pdfRef.current.outerHTML;
      setSendLoading(true);
      await handlePDFDownload(string, {
        fileName: "Invoice" || "",
      }).finally(() => setSendLoading(false));
    }
  };

  const handleSend = async (send) => {
    if (send && pdfRef?.current) {
      let string = pdfRef.current.outerHTML;
      data.pdf = `
      <html>
          <head>
            <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
          </head>
          <body>${string}</body>
      </html>
      `;
      data.sendNow = ["email"];
    }
    await createInvoice({
      data,
      setLoading: send ? setSendLoading : setSaveLoading,
      callback: () => {
        setOpen(false);
        onDone();
      },
    });
  };

  const Footer = () => {
    return (
      <div className="w-full flex flex-col pt-2 bg-white static bottom-0">
        <hr className="border-gray-300 my-3 mb-6" />
        <div className="flex gap-4 items-center">
          <button
            className="flex items-center w-full justify-center text-black flex-1 font-semibold h-12 rounded-lg text-sm fonr-semibold"
            onClick={() => {
              setOpen(false);
              onClose();
            }}
          >
            <span>Go back</span>
          </button>
          <button
            className="bg-[#F9F9F9] text-[#6D7C94] border border-[#E0E0E0] disabled:bg-gray-500 disabled:cursor-not-allowed flex items-center justify-center flex-1 w-full h-12 rounded-lg text-sm font-semibold"
            onClick={() => handleSend()}
          >
            {saveLoading ? (
              <div className="primaryLoader"></div>
            ) : (
              <span>Save draft</span>
            )}
          </button>
          <button
            className="bg-primary1 disabled:bg-gray-500 disabled:cursor-not-allowed flex items-center justify-center flex-1 text-white w-full h-12 rounded-lg text-sm"
            onClick={() => handleSend(true)}
          >
            {sendLoading ? (
              <div className="buttonLoader"></div>
            ) : (
              <span>Send Request</span>
            )}
          </button>
        </div>
      </div>
    );
  };

  const total = () => {
    const serviceAmount = selectedServices()?.reduce((acc, current) => {
      return acc + (current?.unitPrice || 0) * (current?.quantity || 0);
    }, 0);
    let currency = selectedServices()?.find(
      (service) => service?.currency === "USD"
    )
      ? "USD"
      : "NGN";
    let sum =
      serviceAmount +
      invoiceTaxCalculation({ services: selectedServices(), data: data })
        ?.amount +
      invoiceServiceFeeCalculation({ services: selectedServices(), data })
        ?.amount;
    return formatMoney(sum, getCurrencySymbol(currency));
  };

  return (
    <ModalContainer
      open={open}
      setOpen={setOpen}
      secondary
      padding="px-4 py-6"
      title={"Confirm invoice"}
      subTitle="Confirm details of  your invoice"
    >
      <div className="w-full flex flex-col">
        <div className="hidden">
          <div className="" ref={pdfRef}>
            <InvoicePDFSection data={pdfData} />
          </div>
        </div>
        <div className="w-full">
          <div className="relative overflow-x-auto flex flex-col scroll-hide">
            <div className="flex flex-col p-4 w-full rounded-md">
              <div className="w-full flex flex-col">
                <div className="w-full flex justify-between items-center mb-4">
                  <span className="text-[#6D7C94] text-sm">Invoice NO</span>
                  <span>{data?.invoiceNo}</span>
                </div>
                <span className="text-[#6D7C94] text-sm">Customer</span>
                <div className="w-full p-4 rounded-lg bg-gray-100 flex flex-col mt-1">
                  <span className="font-bold text-lg">{customer()?.name}</span>
                  <div className="w-full flex items-center justify-between">
                    <span className="text-sm">{customer()?.email}</span>
                    <span className="text-sm">{customer()?.address}</span>
                  </div>
                </div>
                <hr className="w-full border-gray-300 my-4" />
                <span className="text-[#6D7C94] text-sm">Service</span>
                {selectedServices()?.map((service, serviceIndex) => (
                  <div
                    className="w-full p-4 rounded-lg bg-gray-100 flex flex-col mt-1"
                    key={serviceIndex}
                  >
                    <div className="w-full flex items-center justify-between">
                      <span className="font-bold text-lg">
                        {service?.quantity} x {service?.service?.title}
                      </span>
                      <span className="font-bold text-lg">
                        {formatMoney(
                          service?.unitPrice * (service?.quantity || 1),
                          getCurrencySymbol(service?.currency)
                        )}
                      </span>
                    </div>
                    <div className="w-full flex items-center justify-between">
                      <span className="text-sm">
                        {service?.service?.description?.join("\n")}
                      </span>
                    </div>
                  </div>
                ))}
                <hr className="w-full border-gray-300 my-4" />
                <div className="w-full flex justify-between items-center">
                  <span className="text-[#6D7C94] text-sm">
                    Tax(
                    {data?.tax?.taxMethod === "Percentage"
                      ? "%"
                      : data?.services?.find(
                          (service) => service?.currency === "USD"
                        )
                      ? "$"
                      : getCurrencySymbol("NGN")}
                    )
                  </span>
                  <span>
                    {
                      invoiceTaxCalculation({
                        services: selectedServices(),
                        data: data,
                      })?.value
                    }
                  </span>
                </div>
                <div className="w-full flex justify-between items-center">
                  <span className="text-[#6D7C94] text-sm">
                    Service fee(
                    {data?.serviceFee?.feeMethod === "Percentage"
                      ? "%"
                      : data?.services?.find(
                          (service) => service?.currency === "USD"
                        )
                      ? "$"
                      : getCurrencySymbol("NGN")}
                    )
                  </span>
                  <span>
                    {
                      invoiceServiceFeeCalculation({
                        services: selectedServices(),
                        data,
                      })?.value
                    }
                  </span>
                </div>
                <span className="text-[#6D7C94] text-sm mt-3">Notes</span>
                <span className="text-sm mt-2">{data?.notes}</span>
                <div className="w-full flex justify-between items-center mt-2">
                  <span className="text-[#6D7C94] text-sm">Due date</span>
                  <span>{moment(data?.date)?.format("MMMM DD, YYYY")}</span>
                </div>
                <hr className="w-full border-gray-300 my-4" />

                <div className="w-full flex justify-between items-center mt-2">
                  <span className="text-[#6D7C94] text-sm">Invoice total</span>
                  <span>{total()}</span>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};
